import { ShopSubscriptionType, SubscriptionScheduleType } from 'types/shopSubscription'
import { Action, Dispatch } from 'redux'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { auth } from 'firebase/index'
import axios from 'axios'
import { RETRIEVE_SCHEDULE_ENDPOINT, RETRIEVE_SUBSCRIPTION_ENDPOINT } from 'constants/urls'
import { Stripe } from 'stripe'
import { retrieveSubscriptionsAction } from 'reducks/shopSubscription/actions'

const retrieveSubscriptions = (shopSubscriptions: ShopSubscriptionType[]) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
    // トークンを取得する
    const token = await auth.currentUser?.getIdToken()
    if (typeof !token === 'undefined') {
      dispatch(hideLoadingAction())
      console.error('認証トークンの取得に失敗しました。')
      return
    }
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    }
    // 先にサブスクリプションスケジュールを取得する
    const subscriptionSchedules: SubscriptionScheduleType[] = await Promise.all(
      shopSubscriptions
        .filter((shopSubscription) => {
          return (
            shopSubscription.stripe_scheduled_subscription_id &&
            shopSubscription.stripe_scheduled_subscription_id !== ''
          )
        })
        .map((shopSubscription) => {
          return axios
            .post(
              RETRIEVE_SCHEDULE_ENDPOINT,
              {
                stripe_scheduled_subscription_id: shopSubscription.stripe_scheduled_subscription_id,
              },
              {
                headers,
              }
            )
            .then((res) => {
              const subscriptionSchedule: Stripe.SubscriptionSchedule = res.data.subscriptionSchedule
              const plan: Stripe.Plan = res.data.plan
              return {
                subscription_schedule: subscriptionSchedule,
                plan: plan,
              }
            })
        })
    )
    // サブスクリプション情報を取得する
    const subscriptions: Stripe.Subscription[] = await Promise.all([
      ...shopSubscriptions
        .filter(
          (shopSubscription) =>
            shopSubscription.stripe_subscription_id && shopSubscription.stripe_subscription_id !== ''
        )
        .map((shopSubscription) => {
          console.log(shopSubscription)
          return axios
            .post(
              RETRIEVE_SUBSCRIPTION_ENDPOINT,
              {
                stripe_subscription_id: shopSubscription.stripe_subscription_id,
              },
              {
                headers,
              }
            )
            .then((res) => {
              const subscription: Stripe.Subscription = res.data.subscription
              return subscription
            })
        }),
      ...subscriptionSchedules
        .filter((subscriptionSchedule) => {
          return (
            subscriptionSchedule.subscription_schedule.subscription &&
            subscriptionSchedule.subscription_schedule.subscription !== ''
          )
        })
        .map((subscriptionSchedule) => {
          return axios
            .post(
              RETRIEVE_SUBSCRIPTION_ENDPOINT,
              {
                stripe_subscription_id: subscriptionSchedule.subscription_schedule.subscription,
              },
              {
                headers,
              }
            )
            .then((res) => {
              const subscription: Stripe.Subscription = res.data.subscription
              return subscription
            })
        }),
    ])

    dispatch(hideLoadingAction())
    dispatch(retrieveSubscriptionsAction(subscriptions, subscriptionSchedules))
  }
}

export default retrieveSubscriptions
